import React, { Component } from 'react';
import { connect } from 'react-redux';
import IconInputComponent from 'sub_components/Common/IconInputComponent';
import CredentialInputComponent from 'sub_components/Common/CredentialInputComponent';
import { PROFILE_PASSWORD_MESSAGE_TEXT } from 'utils/ProfileConstants';
import {
	CONFIRM_PASSWORD_SUCCESS,
	enterNewPassword,
	confirmNewPassword,
	resetRegistrationState,
} from 'actions/registration';
import { VALIDATION_STATUS } from 'utils/PasswordRegistrationConstants';
import PortalMessage from 'sub_components/Common/PortalMessage';
import PasswordResetSuccess from 'sub_components/Login/PasswordResetSuccess';

const CDN_URL = process.env.REACT_APP_CDN_URL;
const key = `${CDN_URL}common/KEY.svg`;
const lock = `${CDN_URL}common/LOCK.svg`;
const Icon = `${CDN_URL}common/Common-password-change-icon-190-x-190.png`;
const loginPageBackground = `${CDN_URL}common/gradient-vector-multiply.png`;

const states = {
	NEW: 'NEW',
	CONFIRM: 'CONFIRM',
};

class PasswordRegistration extends Component {
	constructor(props) {
		super(props);
		this.validations = {
			'Must be at least 8 characters': /^.{8,}$/,
			'Must contain at least one number': /^.*[0-9].*$/,
			'Must contain at least one capital letter': /^.*[A-Z].*$/,
			'Must contain at least one special character:': /[^A-Za-z0-9]+/,
			'Must only contain alphanumeric and special characters': /^[\S\T]+$/,
		};
		this.indicators = ['new_password_indicator', 'confirm_pwd_indicator'];
		this.inputs = { newInput: states.NEW, confirmInput: states.CONFIRM };

		this.state = {
			input: '',
			validationError: false,
			validationComplete: false,
			status: null,
			ready: null,
			newPassword: '',
			newPasswordLength: null,
			showErrorMessage: false,
			error: false,
		};
	}

	validateRegistrationCode = () => {
		this.setState({ validationComplete: true });
	};

	receiveInput = input => {
		const { registration_status, enterNewPassword, confirmNewPassword } = this.props;
		const { newPassword } = this.state;
		const { context } = registration_status;
		const { location } = this.props;
		const matches = location?.pathname.split('/');
		let code = '';
		if (matches) {
			const [, , key] = matches;
			code = key;
		}
		if (context === 'NEW') {
			this.setState({ newPassword: input, newPasswordLength: input.length, currentLength: 0 });
			enterNewPassword(input);
		} else {
			confirmNewPassword(newPassword, input, code);
		}
	};

	checkCompletionCallback = () => {
		console.log('PasswordRegistration#checkCompletionCallback');
	};

	createIcons() {
		return [
			<img src={key} icon='key' className='key_icon' />,
			<img src={lock} icon='lock' className='lock_icon' />,
		];
	}

	createValidations() {
		const { registration_status } = this.props;
		const { newPassword } = this.state;
		const status = registration_status.type;
		const newPwd = newPassword;
		const confirmPwdMatchRegex = new RegExp(
			`^${newPwd.replace(/[\[\[\\\^\$\.\|\?\*\+\(\)\]\+]/g, '\\$&')}$`,
		);
		const validations = {};

		if (status === 'NEW_PASSWORD_SUCCESS' && newPwd) {
			validations['Must match new password'] = confirmPwdMatchRegex;
		}

		return validations;
	}
	/**
	 * If the user has successfully registered their new password,
	 * redirect them to the login page
	 */
	componentDidUpdate(prevProps, prevState) {
		const {
			registration_status,
			registration_status: { isRegistered },
			resetRegistrationState,
			navigate,
		} = this.props;

		if (isRegistered && registration_status.type === CONFIRM_PASSWORD_SUCCESS) {
			setTimeout(() => navigate('/login'), 3000);
			setTimeout(() => resetRegistrationState(), 3000);
		}
		if (prevProps.registration_status.status !== prevState.status) {
			//Perform some operation here
			this.setState({ status: prevProps.registration_status.status });
		}
	}

	componentDidMount() {
		this.validateRegistrationCode();
	}

	showErrorMessage = state => {
		this.setState({ showErrorMessage: state, currentLength: 0 });
	};

	resetPasswordSection = () => {
		const { resetRegistrationState, showErrorMessage } = this.props;

		if (!showErrorMessage) {
			this.showErrorMessage(true);
			setTimeout(() => {
				this.showErrorMessage(false);
				resetRegistrationState();
			}, 4000);
		}
	};
	resetRegistration = () => {
		const { resetRegistrationState } = this.props;
		const { error } = this.state;
		if (!error) {
			this.setState({ error: true, currentLength: 0 });
		}

		setTimeout(() => {
			resetRegistrationState();
			this.setState({ error: false });
		}, 2000);
	};

	validationStatus() {
		const { validationComplete, validationError } = this.state;

		if (!validationComplete) {
			return VALIDATION_STATUS.LOADING;
		} else if (validationComplete && validationError) {
			return VALIDATION_STATUS.ERROR;
		} else {
			return VALIDATION_STATUS.SUCCESS;
		}
	}
	onChangeCallback = input => {
		this.setState({ currentLength: input });
	};

	render() {
		const status = this.validationStatus();
		const { registration_status } = this.props;
		const { newPasswordLength, showErrorMessage, currentLength, error } = this.state;

		return (
			<div className={`login-page registration`}>
				<div key='login-image' className='purple-background'>
					<img key='login-img' alt='' src={loginPageBackground} className='gradient-img' />
				</div>
				<div className='password-change'>
					<PortalMessage
						start={PROFILE_PASSWORD_MESSAGE_TEXT.START}
						content={PROFILE_PASSWORD_MESSAGE_TEXT.CONTENT}
					/>
					<div className='wrapper'>
						<IconInputComponent icon={Icon} showErrorMessage={showErrorMessage}>
							{registration_status.type === 'CONFIRM_PASSWORD_SUCCESS' ||
								(registration_status.type === 'CONFIRM_PASSWORD_ERROR' && this.resetRegistration())}
							{registration_status.type === 'CONFIRM_PASSWORD_SUCCESS' && (
								<PasswordResetSuccess modal={true} status={registration_status.type} />
							)}
							{registration_status.type === 'CONFIRM_PASSWORD_ERROR' && (
								<PasswordResetSuccess modal={true} status={registration_status.type} />
							)}
							{status === VALIDATION_STATUS.SUCCESS && (
								<CredentialInputComponent
									error={error}
									initialPasswordLength={newPasswordLength}
									resetFields={this.resetPasswordSection}
									icons={this.createIcons()}
									indicators={this.indicators}
									inputs={this.inputs}
									inputEnterCallback={this.receiveInput}
									inputLengthCallback={this.onChangeCallback}
									checkCompletionCallback={this.checkCompletionCallback}
									validationRules={{
										[states.NEW]: this.validations,
										[states.CONFIRM]: this.createValidations(),
									}}
									inputType={{ [states.NEW]: 'search', [states.CONFIRM]: 'search' }}
									status={registration_status}
									location='bottom'
									tooltipClassName='password-change'
								/>
							)}
							{currentLength >= 8 && !showErrorMessage && (
								<div className='confirm-text body10'>Press enter to confirm your password.</div>
							)}
						</IconInputComponent>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		registration_status: state.registration_status,
	};
}

export default connect(mapStateToProps, {
	enterNewPassword,
	confirmNewPassword,
	resetRegistrationState,
})(PasswordRegistration);
